import { DatePicker } from "antd";
import 'antd/dist/antd.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import moment from 'moment';
import propTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { getRooms } from '../../actions/room';
import { url } from "../../utils/api";
import Loader from '../layout/Loader';
import RoomsCarousel from './RoomsCarousel';

AOS.init({
    duration: 1200,
});
  
const { RangePicker } = DatePicker;

const Room = ({ auth: { user, isAuthenticated}, room:{rooms}, getRooms }) => {

    useEffect(() => {
      getRooms()
    }, [getRooms]);

    const [availableRooms, setAvailableRooms] = useState(rooms);
    const [duplicaterooms, setduplicaterooms] = useState([]);
    const [datefrom, setdatefrom] = useState('');
    const [dateto, setdateto] = useState('')
    const [loading, setloading] = useState(false);
    const [roomtype, setroomtype] = useState('All')
    

    function filterByDate(dates) {
        setdatefrom(moment(dates[0]).format('DD-MM-YYYY'));
        setdateto(moment(dates[1]).format('DD-MM-YYYY'));

        var temp = [];

        for(const room of duplicaterooms) {
            var availability = false;
            if (room.currentbookings.length > 0) {
                for (const booking of room.currentbookings) {
                    if(room.currentbookings.length){
                        if(
                            !moment(moment(dates[0]).format('DD-MM-YYYY')).isBetween(booking.datefrom, booking.dateto) &&
                            !moment(moment(dates[1]).format('DD-MM-YYYY')).isBetween(booking.datefrom, booking.dateto)
                        ) {
                            if(
                                moment(dates[0]).format('DD-MM-YYYY') !== booking.datefrom &&
                                moment(dates[0]).format('DD-MM-YYYY') !== booking.dateto &&
                                moment(dates[1]).format('DD-MM-YYYY') !== booking.datefrom &&
                                moment(dates[1]).format('DD-MM-YYYY') !== booking.dateto
                            ) {
                                availability = true;
                            }
                        }
                    }
                }
                if(availability === true || room.currentbookings.length === 0) {
                    temp.push(room);
                }
                setAvailableRooms(temp);
            }
        }
    }

    useEffect(() => {
        const loadRooms = async () => {
            setloading(true);
            const rooms = await (await axios.get(`${url}/api/rooms`)).data;
            //console.log(rooms);
            setAvailableRooms(rooms);
            setduplicaterooms(rooms);
            setloading(false);
        }
        loadRooms();
    }, []);

    function filterByType(e) {
        setroomtype(e)
        if(e !== 'All') {
            const dupdate = duplicaterooms.filter(room => room.roomtype.toLowerCase().includes(e.toLowerCase()));
            setAvailableRooms(dupdate);
        }
        else{
            setAvailableRooms(duplicaterooms);
        }
    }

    return (
    <>
        <RoomsCarousel />
        <div className='container'>
            {isAuthenticated && user && user.usertype === 'guest' &&
                <div style={{textAlign: 'right'}}>
                    <Link to='/conferencebookings'><button type="button" class="btn btn-warning" >Your Room Bookings</button></Link>
                </div>
            }
            <div className="row bs p-3 m-5 dark" data-aos="fade-up">
                <div className="col-md-2">
                        <h5 style={{marginTop: '10px'}}>Search Rooms</h5>
                </div>
                <div className="col-md-6">
                        <RangePicker style={{ height: "38px", width: "98%" }} onChange={filterByDate} format='DD-MM-YYYY' className='m-2' />
                </div>

                <div className="col-md-4">
                    <select className="form-control m-2" value={roomtype} onChange={(e) => { filterByType(e.target.value) }} >
                        <option value={"All"}>All</option>
                        <option value={"Deluxe Double Bed"}>Deluxe Double Bed</option>
                        <option value={"Non-Deluxe Double Bed"}>Non-Deluxe Double Bed</option>
                        <option value={"Suite"}>Suite</option>
                        <option value={"Couple"}>Couple</option>
                        <option value={"Twin Double Bed"}>Twin Double Bed</option>
                        <option value={"Twin Single Bed"}>Twin Singe Bed</option>
                    </select>
                </div>
            </div>

            <div className="row justify-content-center mt-5"  >
                {loading ? (
                    <Loader />
                ) : (
                    <div className="col-md-9 mt-2">
                        {availableRooms.map((room) => (
                            <div className='row bs' key={room._id} data-aos='zoom-in'>
                                <div className='col-md-4'>
                                    <img src={room.imageurl[0]} alt = 'room img'></img>
                                </div>
                                <div className='col-md-7'>
                                    <h4>{room.roomtype}</h4>
                                    <p>Max Count: {room.maxcount}</p>
                                    <p>Room Number: {room.roomno}</p>

                                    <div style={{ float: 'right', paddingLeft: '14px' }}>
                                        {(datefrom && dateto) && isAuthenticated && user && user.usertype === 'guest' && (
                                            <LinkContainer to={`/bookroom/${room._id}/${datefrom}/${dateto}`}>
                                                    <button className='btn btn-outline-success'>Book Now</button>
                                            </LinkContainer>)
                                        }
                                        {(datefrom && dateto) && !isAuthenticated && (
                                            <Link to='/guestLogin'>
                                                <button className='btn btn-outline-success'>Login to Book</button>
                                            </Link>)
                                        }
                                    </div>
                                    
                                    <div style={{ float: 'right', paddingLeft: '14px' }}>
                                        <LinkContainer to={`/room/${room._id}`}>
                                            <button className='btn btn-outline-warning'>More Info</button>
                                        </LinkContainer>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <hr style={{paddingTop: '20px', paddingBottom: '20px'}}/>
        </div>
    </>
)};

Room.propTypes = {
    auth: propTypes.object.isRequired,
    room: propTypes.object.isRequired,
    getRooms: propTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth,
    room: state.room
})

export default connect(mapStateToProps, {getRooms})(Room);